import {Provider} from "react-redux";
import store from "./redux/store";
import Header from "./components/Header";
import Form from "./components/Form";
import Table from "./components/Table";
import TableData from "./components/TableData";
function App() {
  return (
    <Provider store={store}>    
      <Header />
      <section>
        <Form />
        <Table>
          <TableData />          
        </Table>    
      </section>
    </Provider>
  );
}
export default App;
